import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Field} from 'formik';
import LabelInfo from "../LabelInfo";
import LabelInput from "../LabelInput";
import styles from './styles.module.scss';

const FieldInput = ({
                      fieldId,
                      type = 'text',
                      label = null,
                      info = null,
                      containerStyles = null,
                      ...rest
                    }) => {
  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {({ field, meta }) => (
        <div className={classnames(styles.inputContainer, containerStyles)}>
          <div className={styles.labelContainer}>
            <LabelInput label={label} />
            <LabelInfo label={info} />
          </div>
          <input
            className={classnames(styles.input, {[styles.errorBorder]: meta.error && meta.touched})}
            type={type}
            {...field}
            {...rest}
          />
        </div>
      )}
    </Field>
  )
};

FieldInput.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  type: PropTypes.oneOf(['text', 'number', 'email', 'password', 'tel']),
  label: PropTypes.node,
  info: PropTypes.node,
  containerStyles: PropTypes.string,
};

export default FieldInput;
